// Add a clip: drop the files in /public/video/ and add one line here.
export const VIDEOS = [
  { id: "vamp-clip", title: "Vamp Clip", tag: "Image to Video", src: "/video/vamp-clip.mp4", poster: "/video/vamp-clip-poster.jpg" },
];

export const MIN_SLOTS = 4;
